import { useMutation, useQueryClient } from '@tanstack/react-query';
import { tradesService } from '@/services/trades/trades-service';
import { tradesKeys } from '@/services/query-keys/trades-keys';

/**
 * LR-544: manual "Open now" for a pending position. Invalidates the whole
 * `['positions']` prefix on success so the detail page + blotter refetch and
 * the status updates without a reload (mirrors useRetryTrade).
 */
export const useProcessTradeDate = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id }: { id: number }) => tradesService.processTradeDate(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: tradesKeys.all });
    },
  });
};
